<div class="grid-row grid-gap-1">
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <legend class="usa-legend usa-legend--medium">HHG View Rates</legend>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <div class="usa-alert usa-alert--info usa-alert--no-icon bg-accent-warm define-left-border margin-y-2">
      <div class="usa-alert__body">
        <p class="usa-alert__text">
          Status: U - Unmodified, N - New, M - Modified, D - Deleted
        </p>
      </div>
    </div>
  </div>
  @if (showExport) {
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <button class="usa-button" type="button" (click)="onBtExport()">Export to CSV</button>
    </div>
  }
</div>
@if (carrierId !== null && carrierId !== undefined) {
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-bottom-205">
      <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export the data only from this page. For all the records, please use  "Export to CSV" button above.
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <ag-grid-angular class="ag-theme-alpine" id="myGrid" [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [components]="components"
        [gridOptions]="gridOptions"
        [rowSelection]="rowSelection"
        [suppressDragLeaveHidesColumns]="true"
        [domLayout]="domLayout"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate"
        [overlayLoadingTemplate]="overlayLoadingTemplate"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
    </div>
  </div>
}
